import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap/";
import {
  Visibility,
  Star,
  Favorite,
  VerifiedUser,
  Groups,
  Handshake,
  Balance,
  AutoAwesome,
  Psychology,
} from "@mui/icons-material";

import UserService from "../services/user.service";
import logo from "../assets/logoAux.png";
import wsp from "../assets/wsp.png";
import "./Home.css";

const Home = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    UserService.getPublicContent().then(
      (response) => setContent(response.data),
      (error) => {
        const _content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        setContent(_content);
      }
    );
  }, []);

  return (
    <div className="home">
      {/* ===== HERO CON VIDEO ===== */}
      <section className="hero">
        <video
          className="hero__video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/videos/hero-video.mp4" type="video/mp4" />
          Tu navegador no soporta videos HTML5.
        </video>
        <div className="hero__overlay" />
      </section>

      {/* ===== ¿QUIÉNES SOMOS? ===== */}
      <section className="about">
        <Container>
          <h2 className="section-title">¿Quiénes Somos?</h2>
          <div className="section-divider" />
          <p className="about__text">
            Somos una empresa con una trayectoria sólida en el rubro mayorista
            de Librería, Mercería y Juguetería. Nos motiva la constante
            preocupación por nuestros clientes, ofreciendo junto con nuestro
            personal una atención profesional, eficaz y cordial. Nuestra
            experiencia en el mercado nos permite brindar seguridad y
            satisfacción a toda nuestra clientela.
          </p>
        </Container>
      </section>

      {/* ===== MISIÓN + VISIÓN ===== */}
      <section className="mv">
        <Container>
          <Row>
            <Col md={6} className="mb-4 mb-md-0">
              <div className="mv__card">
                <Visibility className="mv__icon" />
                <h3>Nuestra Misión</h3>
                <p>
                  Somos una empresa que demuestra una constante preocupación por
                  sus clientes, ofreciendo junto con nuestro personal, una
                  atención profesional, eficaz, cordial y con una gran
                  experiencia en el mercado, brindando así una alta seguridad y
                  satisfacción a nuestra clientela.
                </p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mv__card">
                <Star className="mv__icon" />
                <h3>Nuestra Visión</h3>
                <p>
                  Ser los líderes en el rubro mayorista de Librería, Mercería y
                  Juguetería, siendo reconocidos como la empresa de mayor
                  trayectoria y confiabilidad del mercado. Y así, con una
                  constante preocupación por nuestros clientes, poderles brindar
                  el apoyo, asesoramiento y respaldo que estos nos soliciten.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ===== VALORES ===== */}
      <section className="valores">
        <Container>
          <h2 className="section-title">Nuestros Valores</h2>
          <div className="section-divider" />
          <p className="section-subtitle">
            Los pilares que guían nuestro trabajo diario
          </p>
          <Row>
            {[
              {
                icon: <Psychology />,
                label: "Humildad",
                desc: "Reconociendo nuestros defectos para mejorarlos y llevando nuestras virtudes a su máxima expresión.",
              },
              {
                icon: <Favorite />,
                label: "Pasión",
                desc: "Comprometiéndonos con nuestras fuerzas, el corazón, el alma y la mente en todo lo que emprendamos.",
              },
              {
                icon: <VerifiedUser />,
                label: "Integridad",
                desc: "Siendo muy transparentes con nuestro personal, proveedores y clientes.",
              },
              {
                icon: <Groups />,
                label: "Colaboración",
                desc: "Incentivando el trabajo en equipo para crear un esfuerzo sinérgico.",
              },
              {
                icon: <Handshake />,
                label: "Compromiso",
                desc: "Brindando nuestros servicios y ofreciendo nuestra ayuda tanto en la venta como en el post-venta.",
              },
              {
                icon: <Balance />,
                label: "Coherencia",
                desc: "Entre nuestros valores y nuestros objetivos.",
              },
              {
                icon: <VerifiedUser />,
                label: "Confianza",
                desc: "Evitando defraudar a clientes, proveedores y personal, siendo la confianza mutua la base de una relación duradera.",
              },
              {
                icon: <AutoAwesome />,
                label: "Calidad",
                desc: "Buscando en todo momento la excelencia.",
              },
            ].map((v, i) => (
              <Col key={i} xs={12} sm={6} lg={3} className="mb-3">
                <div className="valor__item">
                  <div className="valor__icon">{v.icon}</div>
                  <strong>{v.label}</strong>
                  <span>{v.desc}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ===== HORARIO ===== */}
      <section className="horario">
        <Container>
          <h4>
            Nuestra atención y venta Mayorista es de 11:30 a 15:30 hs de Lunes
            a Viernes.
            <br />
            NO CONTAMOS CON VENTA MINORISTA.
            <br />
            Para más información o consultas, pónganse en contacto con nosotros.
          </h4>
        </Container>
      </section>

      {/* ===== MAPA + WHATSAPP ===== */}
      <section className="mapa-contacto">
        <Container>
          <h2 className="section-title">Contacto</h2>
          <div className="section-divider" />
          <p className="section-subtitle">Encontranos o escribinos</p>
          <Row>
            <Col md={7} className="mb-4 mb-md-0">
              <iframe
                className="mapa__frame"
                title="Mapa Karam José e Hijos"
                src="https://maps-api-ssl.google.com/maps?hl=es-419&amp;ll=-31.530611,-68.521914&amp;output=embed&amp;q=Av.+Rioja+Norte+360,+J5400+EMQ,+San+Juan,+Argentina+(Karam+Jos%C3%A9+e+Hijos+Mercer%C3%ADa+y+Librer%C3%ADa)&amp;z=16"
                allowFullScreen
                loading="lazy"
              />
            </Col>
            <Col md={5}>
              <a
                href="https://wa.me/5492644605714?text=Hola, quisiera hacer una consulta."
                target="_blank"
                rel="noreferrer"
                className="wsp__card"
              >
                <img src={wsp} alt="WhatsApp" />
                <p>Contáctese con nosotros por WhatsApp</p>
                <p style={{ fontSize: "0.95rem", fontWeight: 400, marginTop: 8 }}>
                  José Karam e Hijos
                </p>
              </a>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ===== UBICACIÓN ===== */}
      <section className="ubicacion">
        <Container>
          <p>
            Nos encontramos en Av. Rioja, 360 (Norte) entre Calles Maipú y
            Pedro Echagüe — San Juan, Argentina.
          </p>
        </Container>
      </section>
    </div>
  );
};

export default Home;
